import autumnForest from "./autumnForest";
import brown from "./brown";
import candlelight from "./candlelight";
import cherry from "./cherry";
import colorful from "./colorful";
import cyan from "./cyan";
import defaultTheme from "./default";
import factory from "./factory";
import forest from "./forest";
import frozen from "./frozen";
import green from "./green";
import grey from "./grey";
import orange from "./orange";
import pink from "./pink";
import prismatic from "./prismatic";
import purple from "./purple";
import rain from "./rain";
import red from "./red";
import sepia from "./sepia";
import sky from "./sky";
import polar from "./polar";
import waves from "./waves";
import yellow from "./yellow";
import dream from "./dream";

export default {
    default: defaultTheme,
    cyan,
    green,
    yellow,
    orange,
    brown,
    red,
    pink,
    purple,
    grey,
    sepia,
    factory,
    forest,
    cherry,
    polar,
    sky,
    prismatic,
    candlelight,
    colorful,
    rain,
    waves,
    autumnForest,
    frozen,
    dream,
}
